const types = {
  UPDATE: '@order/cancel/formJustification/UPDATE',
  RESET: '@order/cancel/formJustification/RESET',
  SELECT_ORDER: '@order/cancel/SELECT',
  UNSELECT_ORDER: '@order/cancel/UNSELECT',
  CONFIRM_CANCEL: '@order/cancel/CONFIRM',
};

export default types;
